<template>
  <div class="content-center">
    <div class="contact">
      <ul class="left">
        <li @click="linkTo('aboutUs')"><span>关于我们</span></li>
        <li @click="linkTo('law')"><span>法律声明</span></li>
        <li @click="linkTo('cooperate')"><span>联系方式</span></li>
        <li @click="linkTo('contact')"><span>意见反馈</span></li>
        <li @click="linkTo('zhaopin')"><span>人才招聘</span></li>
        <li @click="linkTo('document')"><span>纪检监察</span></li>
      </ul>
      <ul class="right">
        <li>
          <img src="../../assets/Mobile/images/home/weixin.png" alt="" style="float:right">
          <span>汇通达微信号</span>
        </li>
      </ul>
    </div>
    <div class="tel">
      <div class="left">
        <p>业务合作：4006399988</p>
        <p>人才招聘：hr.zhaopin@htd.cn</p>
        <p>监察举报：025-68727986</p>
        <p>举报邮箱：jjjc@htd.cn</p>
      </div>
      <ul class="right">
        <li>
          <img src="../../assets/Mobile/images/home/join.png" alt="" style="float:right">
          <span>加入汇通达</span>
        </li>
      </ul>
    </div>
    <p class="copyright">
      <span>Copyright@2013-{{ new Date().getFullYear() }} 汇通达网络股份有限公司 版权所有</span><br>
      <span class="border" @click="linkTo('Integrated')">苏公网安备 32010202010366号</span>
      <span @click="linkTo('registerSystemInfo')">苏ICP备11002532号-3</span><br>
      <span>合字B2-20210051</span>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    linkTo(val) {
      if (val === 'aboutUs') this.$router.push({ path: 'aboutUs' })
      if (val === 'law') location.href = 'https://mall.htd.cn/footLink/aboutUs?type=2'
      if (val === 'cooperate') this.$router.push({ path: 'cooperate' })
      if (val === 'contact') location.href = 'https://b.qq.com/webc.htm?new=0&sid=4006399988&eid=218808P8z8p8y8R8q8p8K&o=&q=7&ref=http://mall.htd.cn/'
      if (val === 'zhaopin') location.href = 'https://app.mokahr.com/apply/huitongda/3951#/'
      if (val === 'document') location.href = 'http://htd.cn/other/document.docx'
      if (val === 'Integrated') location.href = 'https://beian.miit.gov.cn/#/Integrated/index'
      if (val === 'registerSystemInfo') location.href = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010202010366'
    }
  }
}
</script>

<style lang="less" scoped>
  .content-center {
    background: #000;
    padding: 17px 30px 41px 25px;
    .contact {
      width: 100%;
      display: flex;
      align-items: center;
      ul{
        margin-bottom: 0;
      }
      .left{
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        li{
          margin: 8px 20px 7px 0;
          width: 80px;
          height: 30px;
          line-height: 30px;
          font-size: 13px;
          color: #fff;
          background: rgba(255, 255, 255, .1);
        }
      }
      .right{
        flex: 0 0 90px;
        li{
          img{
            margin-bottom: 9px;
            height: 90px;
            line-height: 90px;
          }

          span {
            font-size: 13px;
            line-height: 14px;
            color: #fff;
          }
        }
      }
    }

    .tel {
      margin: 35px 0 42px;
      display: flex;
      align-items: center;
      ul{
        margin-bottom: 0;
      }
      .left{
        padding-left: 12px;
        flex: 1;
        border-left: 1px solid rgba(255, 255, 255, .24);
        p {
          margin-bottom: 17px;
          font-size: 14px;
          line-height: 15px;
          color: #fff;
          text-align: left;
        }
        p:last-of-type {
          margin: 0;
        }
      }
      .right{
        flex: 0 0 90px;
        li{
          img{
            margin-bottom: 9px;
            height: 90px;
            line-height: 90px;
          }

          span {
            font-size: 13px;
            line-height: 14px;
            color: #fff;
          }
        }
      }
    }
    .copyright {
      span {
        margin-bottom: 4px;
        display: inline-block;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, .6);
        line-height: 13px;
      }

      .border {
        border-right: 1px solid rgba(255, 255, 255, .45);
        padding-right: 4px;
        margin-right: 4px;
      }
    }
  }
</style>
